import { useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Small shared fetch hook for public site-content surfaces (feed / conferences /
// announcement). Public endpoints only — never touches the enquiry inbox.
function useSitePublic(path) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${API}${path}`);
      setData(res.data);
    } catch (e) {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [path]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, reload: load };
}

export const useFeedItems = () => useSitePublic("/site/feed");
export const useConferences = () => useSitePublic("/site/conferences");
export const useAnnouncement = () => useSitePublic("/site/announcement");
